<div class="service-down-notifier-section">
        <div class="scroll-text mat-subtitle-2 m-0">
            {{ pageMessages.SERVICE_DOWN_NOTE }}
        </div>
    <mat-icon [matTooltip]="'show all warnings'" class="material-symbols-outlined service-down-action cursor-pointer" (click)="openAllWarnings()">
        read_more
    </mat-icon>
</div>

<ng-template #serviceDownDialogTemp>
  <!-- Title -->
  <h2 mat-dialog-title class="dialog-title">Warning</h2>

  <!-- Content -->
  <mat-dialog-content class="dialog-content">
    <div class="mat-subtitle-2 no-margin">
      {{ pageMessages.SERVICE_DOWN_ST }}
    </div>

    <ul class="warning-list">
      <li class="mat-subtitle-2 no-margin" *ngFor="let warnListItem of serviceDownBannerList">
        [{{ warnListItem.service_name | titlecase }}] {{ warnListItem.message }}
      </li>
    </ul>
  </mat-dialog-content>

  <!-- <mat-divider></mat-divider> -->

  <!-- Actions -->
  <mat-dialog-actions align="end" class="dialog-actions">
    <button mat-button (click)="closeAllWarnings()" color="accent" class="mat-button">OKAY</button>
  </mat-dialog-actions>
</ng-template>